import axiosInstance from "api/axiosInstance";

import type { InstructorPaymentRecord, PaymentRecordListParams, InstructorPaymentSetting, PaymentRecordUpdateAmountRequest, PaymentRecordUpdateAmountResponse, PaymentRecordReissueRequest, PaymentRecordReissueResponse, PracticePaymentRecordListItem, PracticePaymentRecordListParams } from "api/types/payment.types";
import type { PaginatedResponse } from "api/types/product.types";

const RECORDS_BASE = "/server/buccl_payment/api/v1/records/";
const SETTINGS_BASE = "/server/buccl_payment/api/v1/settings/";
const PRACTICE_RECORDS_BASE = "/server/buccl_payment/api/v1/practice-records/";

export const paymentsService = {
  listRecords: (params?: PaymentRecordListParams) => axiosInstance.get<PaginatedResponse<InstructorPaymentRecord>>(RECORDS_BASE, { params }),

  getRecord: (id: number) => axiosInstance.get<InstructorPaymentRecord>(`${RECORDS_BASE}${id}/`),

  approveRecord: (id: number) => axiosInstance.post(`${RECORDS_BASE}${id}/approve/`),

  payRecord: (id: number) => axiosInstance.post(`${RECORDS_BASE}${id}/mark_paid/`),

  cancelRecord: (id: number, reason?: string) => axiosInstance.post(`${RECORDS_BASE}${id}/cancel/`, { reason }),

  // 정산 금액 수정 (CALCULATED 상태에서만 가능)
  updateRecordAmount: (id: number, payload: PaymentRecordUpdateAmountRequest) => axiosInstance.patch<PaymentRecordUpdateAmountResponse>(`${RECORDS_BASE}${id}/update_amount/`, payload),

  // 정산 재발행 (강사 변경 / 금액 보정 / 분할 정산)
  reissueRecord: (id: number, payload: PaymentRecordReissueRequest) => axiosInstance.post<PaymentRecordReissueResponse>(`${RECORDS_BASE}${id}/reissue/`, payload),

  listSettings: (params?: { instructor?: number }) => axiosInstance.get<PaginatedResponse<InstructorPaymentSetting>>(SETTINGS_BASE, { params }),

  // 연습반 정산 기록 목록
  listPracticeRecords: (params?: PracticePaymentRecordListParams) =>
    axiosInstance.get<PaginatedResponse<PracticePaymentRecordListItem>>(PRACTICE_RECORDS_BASE, {
      params,
    }),
};
